import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

export default function HomePageRedirection() {
  return (
    <Redirect to="/jobs" />
  );
}
